module.exports = __webpack_public_path__ + "static/user_view_with_customer-88df46cae02065560f45e53c497655dc.png";